import { render, staticRenderFns } from "./SurveyReadExamples.vue?vue&type=template&id=37c7c94e"
import script from "./SurveyReadExamples.ts?vue&type=script&lang=ts&external"
export * from "./SurveyReadExamples.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports